// extracted by mini-css-extract-plugin
export var actions = "_41-0";
export var actionsContainer = "_41-6";
export var border = "_41-1";
export var childFullHeight = "_41-d";
export var collapse = "_41-2";
export var content = "_41-8";
export var contentChild = "_41-c";
export var fullscreen = "_41-a";
export var headerContainer = "_41-3";
export var headerRow = "_41-5";
export var hidePadding = "_41-9";
export var noScrollX = "_41-e";
export var noScrollY = "_41-f";
export var optOutTopPadding = "_41-b";
export var pagePadding = "_41-7";
export var profile = "_41-g";
export var profileContainer = "_41-h";
export var profileImage = "_41-i";
export var profileMain = "_41-j";
export var profileSubtitle = "_41-l";
export var profileTitle = "_41-k";
export var tabsWrapper = "_41-4";
export var title = "_41-m";